import { forwardRef, useImperativeHandle } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useSocket } from "../../../components/Socket";
import { notification } from "antd";
import APICall from "../../../APICall";
import EndPoints from "../../../APICall/EndPoints";
import { setWatchListArray } from "../../../store/slice/marketWatchSlice";

const ScriptLogic = forwardRef(
  (
    {
      value,
      setValue,
      setExpiryDatesList,
      setStrikePriceOptions,
      setAddLoading,
      positionData,
      show,
    },
    ref
  ) => {
    const socketContext = useSocket();
    const { doSend, socketData } = socketContext;
    const dispatch = useDispatch();

    //redux
    const watchList = useSelector(
      (state) => state?.marketWatchSlice?.watchListArray
    );
    const selectedIndex = useSelector(
      (state) => state?.marketWatchSlice?.seletctedMaketIndex
    );
    const watchListId = watchList?.[selectedIndex]?._id;

    // function
    const resetAllStats = () => {
      let option = false;
      if (value?.marketName === "NSE OPT" || value?.marketName === "MCX OPT") {
        option = true;
      }

      if (!option) {
        setExpiryDatesList([]);
        setStrikePriceOptions([]);
        setValue({
          marketName: value.marketName,
          Exchange: null,
          instrument_type: null,
          script: null,
          expiryDate: null,
          option_type: null,
          strikePrice: null,
        });
      } else {
        setValue({
          ...value,
          marketName: value.marketName,
          Exchange: null,
          instrument_type: null,
          script: option ? value.script : null,
          expiryDate: option ? value.expiryDate : null,
          option_type: option ? value.option_type : null,
          strikePrice: null,
        });
      }
    };

    //api
    const addScript = async (value) => {
      setAddLoading(true);
      await APICall("post", EndPoints.addScript, [value])
        .then((response) => {
          if (
            (response.status === 201 || response.status === 200) &&
            response.data
          ) {
            let data = response?.data?.data[0];
            let newPosition = positionData?.data?.filter(
              (item) => item?.symbol === data?.symbol
            );
            let dummyObj = {
              ...value,
              _id: data?._id,
              // marketName: data?.symbolName,
              expiryDate: data?.expiryDate,
              InstrumentIdentifier: value?.symbol,
              symbol: data?.symbol,
              series: data?.series,
              symbol: data?.symbol,
              symbolName: data?.symbolName,
              positions: newPosition,
            };
            // console.log("dummyObj===>", dummyObj);

            if (data?.symbol) {
              doSend({
                event: "subscribeToServerMarket",
                payload: [data?.symbol],
              });
            }

            dispatch(
              setWatchListArray({
                type: "scriptAdd",
                data: dummyObj,
                index: selectedIndex,
              })
            );

            resetAllStats();
            notification?.success({
              message: response.data?.message,
            });
          } else if (response.status === 409 || response.status === 500) {
            console.log("error", response);
            notification?.error({
              message: response.data?.message,
            });
          }
        })
        .catch((error) => {
          console.log("error", error);
          notification?.error({
            message: error?.response?.data?.message,
          });
        })
        .finally(() => {
          setAddLoading(false);
        });
    };

    const checkScript = () => {
      if (!value?.marketName || !value?.script) {
        notification?.info({
          message: "Please fill out the form",
        });
        return;
      }
      if (show?.expiry && !value?.expiryDate) {
        notification?.info({
          message: "Please fill out the form",
        });
        return;
      }
      if (show?.option && (!value?.option_type || !value?.strikePrice)) {
        notification?.info({
          message: "Please fill out the form",
        });
        return;
      }

      if (value?.script && value?.marketName) {
        let isPresent = watchList?.[selectedIndex]?.scriptList?.some(
          (el) => el?.symbolId === value?.symbolId
        );
        if (isPresent) {
          return notification.info({
            message: "Script allready available in watch list",
          });
        } else {
          addScript({ ...value, deviceType: "WEB", watchListId: watchListId });
        }
      }
    };

    useImperativeHandle(
      ref,
      () => ({
        callCheckScript: () => checkScript(),
      }),
      [checkScript]
    );
  }
);

export default ScriptLogic;
